import { useTranslation } from 'react-i18next';
import { Link } from '@/components/Elements/Link';
import ConnectDotsImage from '../assets/images/connect-dots.png';
import { useTagViewDialog } from '../hooks/useTagViewDialog';

export const ConnectDotsThemesMenu = () => {
  const { t } = useTranslation();
  const { open: openTagView } = useTagViewDialog();

  const linkTo = `/analyze/search`;

  return (
    <div className="w-full max-w-6xl rounded-tr-3xl bg-white/60 backdrop-blur-xl">
      <h2 className="px-8 py-4 text-2xl font-semibold text-black shadow-xl shadow-white/20">
        {t('タグを探索')}
      </h2>

      <div className="p-4 shadow-xl shadow-white/20">
        <Link
          to={linkTo}
          onClick={openTagView} // クリック時にダイアログを開く
          className="w-full items-center justify-center space-x-5 rounded-tr-xl bg-gray-100 text-xl font-medium text-gray-800 transition-colors duration-200 hover:bg-gray-200"
          underline="hover"
        >
          <img
            src={ConnectDotsImage}
            alt={t('TagViewのイメージ')}
            className="mx-auto w-full rounded-lg"
          />
        </Link>
      </div>
    </div>
  );
};
